module.exports = __webpack_public_path__ + "media/images/admin/icons/hash-71ec9b1867e42a90dd12ddb6b9568af2.svg";